import React, {Component} from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import {
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody
} from "@material-ui/core";
import {appHelpers} from "../../_helpers";
import RecordPagination from '../../utils/RecordsPagination';

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Poppins', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    }
};

const RecordTable = (props) => {
    const { classes, data, pageIndex } = props;

    return (
        <div>
            <div className={classes.tableResponsive} style={{ overflowX: "auto" }}>
                <Table className={classes.table} aria-labelledby="tableTitle">
                    <TableHead className={classes.negativeColor} color="primary">
                        <TableRow>
                            <TableCell>S/N</TableCell>
                            <TableCell>Transaction Date</TableCell>
                            <TableCell>Reference</TableCell>
                            <TableCell>Debit</TableCell>
                            <TableCell>Credit</TableCell>
                            <TableCell>Balance</TableCell>
                            <TableCell>Narration</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((item, key) => {
                            return (
                                <TableRow hover key={key}>
                                    <TableCell>{pageIndex + key}</TableCell>
                                    <TableCell padding="none" >{ appHelpers.formatDateSpecific(
                                        item.TransactionDate,
                                        "MMM DD, YYYY"
                                    )}</TableCell>
                                    <TableCell padding="none" >{item.Reference}</TableCell>
                                    <TableCell padding="none" >&#8358; {appHelpers.numberWithCommas(item.Debit)}</TableCell>
                                    <TableCell padding="none" >&#8358; {appHelpers.numberWithCommas(item.Credit)}</TableCell>
                                    <TableCell padding="none" >&#8358; {appHelpers.numberWithCommas(item.Balance)}</TableCell>
                                    <TableCell padding="none" >{appHelpers.removeCharacters(item.Remark)}</TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
};

class paginatedRecordTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const {classes, data, fetchMoreRecord, totalCount, pageSize, currentPage } = this.props;
        const pageIndex = (pageSize * (currentPage - 1)) + 1;
        return (
        <RecordPagination
            fetchMore={fetchMoreRecord}
            totalCount={totalCount}
            pageSize={pageSize}
            currentPage={currentPage}
            target={<RecordTable
                pageIndex={pageIndex}
                classes={classes}
                data={data}
            />}
        />
        )
    }
}

export default withStyles(styles)(paginatedRecordTable);


// WEBPACK FOOTER //
// ./src/views/StatementOfAccount/RecordTable.js